import { customizeError } from '@chilecompra/react-kit'
import { formatDate } from 'date-fns'

import { SANCTIONS_ROWS_PER_PAGE } from '../../config/settings/constant'
import { makeActionCreator } from '../../config/store/utils'
import { checkIfForeignDni } from '../../modules/utils/helpers'
import { getHistoricalSanctionsList, getSanctionVoidInfo } from '../../services/sanction'
import { TYPE_DOCUMENT } from './HistoricalSanctionsList.constants'

/**
 * Utils
 */
const buildErrorPayload = error => ({
  error: customizeError({
    code: error.code,
    originalError: error.originalError,
    reason: 'SOMETHING_WENT_WRONG_ERROR'
  }).toObject()
})

/**
 * Actions
 */
export const CLOSE_SANCTION_VOID_DIALOG = 'CLOSE_SANCTION_VOID_DIALOG'
export const onCloseSanctionVoidDialog = makeActionCreator(CLOSE_SANCTION_VOID_DIALOG)

export const GET_HISTORICAL_SANCTIONS_LIST = 'GET_HISTORICAL_SANCTIONS_LIST'
export const GET_HISTORICAL_SANCTIONS_LIST_ERROR = 'GET_HISTORICAL_SANCTIONS_LIST_ERROR'
export const GET_HISTORICAL_SANCTIONS_LIST_SUCCESS = 'GET_HISTORICAL_SANCTIONS_LIST_SUCCESS'
export const onGetHistoricalSanctionsList = makeActionCreator(GET_HISTORICAL_SANCTIONS_LIST, 'payload')
export const onGetHistoricalSanctionsListError = makeActionCreator(GET_HISTORICAL_SANCTIONS_LIST_ERROR, 'payload')
export const onGetHistoricalSanctionsListSuccess = makeActionCreator(GET_HISTORICAL_SANCTIONS_LIST_SUCCESS, 'payload')
export const onGetHistoricalSanctionsListThunk =
  ({ dni, itemsPerPage = SANCTIONS_ROWS_PER_PAGE, keyword = '', loading = false, page = 1, searching = false }) =>
  async dispatch => {
    dispatch(onGetHistoricalSanctionsList({ loading, searching }))

    try {
      const { data } = await getHistoricalSanctionsList({
        actionType: GET_HISTORICAL_SANCTIONS_LIST,
        dni,
        isForeign: checkIfForeignDni(dni) ? 1 : 0,
        qs: {
          itemsPerPage,
          keyword,
          page
        }
      })

      const sanctions =
        data?.payload?.content?.map(item => ({
          acceptanceDate: (item.fechaaceptacion && formatDate(item.fechaaceptacion, 'dd-MM-yyyy')) || 'Sin información',
          closingDate: (item.fechacierre && formatDate(item.fechacierre, 'dd-MM-yyyy')) || 'Sin información',
          entCodeBuyer: item.entcodecomprador || '',
          id: item.idsancion || '',
          isVoid: !!item.sinEfecto,
          organization: item.nombrecomprador || '',
          processCode: item.codigoProceso || '',
          purchaseOrderCode: item.codigoexterno || '',
          purchaseOrderName: item.nombreproceso || ''
        })) || []

      return dispatch(
        onGetHistoricalSanctionsListSuccess({
          data: sanctions,
          itemsPerPage: data?.payload?.pageSize || SANCTIONS_ROWS_PER_PAGE,
          keyword,
          page: data?.payload?.pageNumber || 1,
          totalPages: data?.payload?.totalPages || 0,
          totalRecords: data?.payload?.totalElements || 0
        })
      )
    } catch (error) {
      if (error?.originalError?.code === 'ERR_CANCELED') return

      return dispatch(onGetHistoricalSanctionsListError(buildErrorPayload(error)))
    }
  }

export const GET_SANCTION_VOID_INFO = 'GET_SANCTION_VOID_INFO'
export const GET_SANCTION_VOID_INFO_ERROR = 'GET_SANCTION_VOID_INFO_ERROR'
export const GET_SANCTION_VOID_INFO_SUCCESS = 'GET_SANCTION_VOID_INFO_SUCCESS'
export const onGetSanctionVoidInfo = makeActionCreator(GET_SANCTION_VOID_INFO, 'payload')
export const onGetSanctionVoidInfoError = makeActionCreator(GET_SANCTION_VOID_INFO_ERROR, 'payload')
export const onGetSanctionVoidInfoSuccess = makeActionCreator(GET_SANCTION_VOID_INFO_SUCCESS, 'payload')
export const onGetSanctionVoidInfoThunk =
  ({ sanctionId }) =>
  async dispatch => {
    dispatch(onGetSanctionVoidInfo())

    try {
      const { data } = await getSanctionVoidInfo({
        actionType: GET_SANCTION_VOID_INFO,
        sanctionId
      })

      const voidInfo = {
        documentFile: data?.payload?.adjuntosWS?.[0]?.nombreArchivo || '',
        documentType: TYPE_DOCUMENT[data?.payload?.adjuntos?.[0]?.tipoDocumento] || '',
        resolutionNumber: data?.payload?.adjuntos?.[0]?.nroDocumento || '',
        supportDocumentDate: data?.payload?.adjuntosWS?.[0]?.fechaDocumento
          ? formatDate(data?.payload?.adjuntosWS?.[0]?.fechaDocumento, 'dd/MM/yyyy')
          : ''
      }

      return dispatch(onGetSanctionVoidInfoSuccess({ data: voidInfo }))
    } catch (error) {
      if (error?.originalError?.code === 'ERR_CANCELED') return

      return dispatch(onGetSanctionVoidInfoError(buildErrorPayload(error)))
    }
  }

export const OPEN_SANCTION_VOID_DIALOG = 'OPEN_SANCTION_VOID_DIALOG'
export const onOpenSanctionVoidDialog = makeActionCreator(OPEN_SANCTION_VOID_DIALOG)
